import { getHumanSensor } from '../../../api/eastCoastDataApi/ElkQuery/humanSensor'
import Utils from '../../../utils/utils'

const state = {
  allHumanSensorData: [],
  humanSensorData: [],

}

const getters = {


  getHumanSensorData: state => {
    // console.log('getHumanSensorData', state.humanSensorData)  
    return state.humanSensorData;
  },

  getAllHumanSensorData: state => {
    return state.allDevice;
  },
}

const actions = {

  async getHumanSensor({ commit }, condition) {
    commit('humanSensorData', await getHumanSensor(condition));
  },

  
}

const mutations = {

  humanSensorData(state, data) {
 if (Utils.isEmptyObject(data)) {
      return
    }
    state.humanSensorData = data.data;
   
  },

 
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}